export { IconFacebook1 } from "./IconFacebook1";
